var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndCallPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 16,
    viewBox: "0 0 40 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.218177 9.90916L3.59396 15.3244C3.96108 15.9124 4.69953 16.1536 5.34093 15.8997L12.0925 13.1921C12.6833 12.9552 13.0504 12.3502 12.9829 11.7156L12.5187 7.0535C17.2743 5.33164 22.6207 5.29356 27.4734 7.0535L27.0092 11.7156C26.9459 12.3545 27.3088 12.9552 27.8996 13.1921L34.6512 15.8997C35.301 16.1536 36.0395 15.9124 36.4066 15.3244L39.7823 9.90916C40.1326 9.34649 40.0566 8.61036 39.5798 8.1323C28.7731 -2.7023 11.2443 -2.71923 0.420723 8.1323C-0.0518868 8.60613 -0.13628 9.34226 0.218177 9.90916Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCallPhone);
export default __webpack_public_path__ + "static/media/end-call-phone.81fa1327c3f6e8b07a4aa71bdea2f73a.svg";
export { ForwardRef as ReactComponent };